import {
  Box,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";
import { useGetAgentsQuery } from "../../../redux/api/agentsApi";
import AutoComplete from "../../FormElements/AutoComplete";
import { useFormContext } from "react-hook-form";
import { useGetAgencyDashboardPriorityQuery } from "../../../redux/api/authApi";
import DonutChart from "../DonutChart";
import BaseCard from "../../BaseCard/BaseCard";
import { useEffect } from "react";

export const RightSection = ({
  agencyId,
  selectAll,
  setSelectAll,
  leadData,
}) => {
  const { data: agents, isFetching } = useGetAgentsQuery(agencyId);

  const { watch } = useFormContext();
  const selectedAgentId = watch("agentid");
  const selectedAgent = agents?.find(
    (agent) => agent.agentid === selectedAgentId
  );

  const { data: priority } = useGetAgencyDashboardPriorityQuery({
    agcId: agencyId,
    agtId: selectedAgentId,
  });

  const handleAgentChange = (agentId) => {
    if (agentId) {
      setSelectAll(false); // Uncheck "Select all" when agent is selected
    }
  };

  return (
    <Box>
      {/* <BaseCard title="Leads by Priority"> */}
      <>
        {/* <Paper elevation={2} sx={{ p: 2 }}> */}
        <Typography
          fontWeight="bold"
          sx={{
            mb: 1,
            backgroundColor: "#b5ffcb",
            p: 1,
            borderRadius: "5px",
            height: "40px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Assigned To: {selectAll ? "All" : selectedAgent?.agentname || "None"}
        </Typography>

        <AutoComplete
          name="agentid"
          label="Search Staff"
          optionId="agentid"
          optionLabel="agentname"
          options={agents || []}
          isLoading={isFetching}
          sx={{ mb: 1 }}
          disabled={selectAll}
          onChangeCallback={handleAgentChange}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={selectAll}
              onChange={(e) => setSelectAll(e.target.checked)}
            />
          }
          label="Select all"
          sx={{ display: "block", ml: 0 }}
        />
        {/* </Paper> */}

        <DonutChart priority={priority} />
      </>
      {/* </BaseCard> */}
    </Box>
  );
};
